import { useState, useCallback } from 'react';

const INTRO_PLAYED_KEY = 'csg_intro_played';

/**
 * Hook to manage intro video state
 * Uses sessionStorage to track if intro has been played this session
 */
export const useIntroVideo = () => {
  const [showIntro, setShowIntro] = useState(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  // Check if intro should be shown (session-based)
  const shouldShowIntro = useCallback(() => {
    return sessionStorage.getItem(INTRO_PLAYED_KEY) !== 'true';
  }, []);

  // Mark intro as played and hide it
  const markIntroPlayed = useCallback(() => {
    sessionStorage.setItem(INTRO_PLAYED_KEY, 'true');
    setShowIntro(false);
  }, []);

  // Trigger the intro to show (if not already played)
  const triggerIntro = useCallback(() => {
    if (shouldShowIntro()) {
      setShowIntro(true);
      return true;
    }
    return false;
  }, [shouldShowIntro]);

  // Reset intro state (for testing)
  const resetIntro = useCallback(() => {
    sessionStorage.removeItem(INTRO_PLAYED_KEY);
    setShowIntro(false);
    setIsVideoLoaded(false);
  }, []);

  return {
    showIntro,
    isVideoLoaded,
    setIsVideoLoaded,
    markIntroPlayed,
    triggerIntro,
    shouldShowIntro,
    resetIntro,
  };
};

export default useIntroVideo;
